import React from "react"
//import { StaticImage } from 'gatsby-plugin-image'
import { graphql } from "gatsby"
import * as styles from "../../styles/page/second.module.scss"

// 共通コンポーネント
import Meta from "../../components/layouts/meta"
import Layout from "../../components/layouts/default"
import BreadCrumb from "../../components/layouts/bread-crumb"

// markup
const IndexPage = ({data}) => {
  const markdownRemark = data.markdownRemark
  const { frontmatter } = markdownRemark
  const { title, description, slug } = frontmatter

  return (
    <Layout>
      <Meta 
        title={title}
        description={description}
        path={slug}
      />

      <BreadCrumb
        currentTitle={title}
      />

      <div className={styles.pageTitle}>
        <h1 className={`${styles.pageTitleHeading} mb-6`}>{title}</h1>
      </div>

      <main className={styles.pageContents}>
      <h2 className={styles.pageContentsHeading2}>Obtaining personal information</h2>
      <p className="pb-1">The New Energy and Industrial Technology Development Organization (hereinafter referred to as “NEDO”) may obtain personally identifiable information through services (such as E-mail distribution, registration, receipt of inquiries, and requests for printed materials) provided at this NEDO Website (hereinafter referred to as the “Website”). NEDO will, when obtaining said information, clarify the purpose of use thereof and handle the information appropriately within the scope of that purpose.</p>
      <p className="pb-2">The personal information of users, such as the following, is necessary to provide each of the Website’s services:</p>
      <ul className="pb-4">
        <li>Name and gender</li>
        <li>Name of organization</li>
        <li>Division and title</li>
        <li>Address and postal code</li>
        <li>Telephone and fax number</li>
        <li>E-mail address</li>
        <li>Other items indispensable for the provision of services</li>
      </ul>

      <h2 className={styles.pageContentsHeading2}>Scope of use of personal information</h2>
      <p className="pb-2">The personal information provided (or registered) by users will be used within the scope of the purpose of use specified in advance and will in no event be provided to any third party other than NEDO, except in cases where:</p>
      <ul className="pb-4">
        <li>provision thereof is required by laws and regulations;</li>
        <li>it should be disclosed to the public and NEDO obtains the consent of the user in question; or</li>
        <li>it is provided within the scope of the purpose of use to any business consignee which has entered into a confidentiality agreement with NEDO.</li>
      </ul>
      
      <h2 className={styles.pageContentsHeading2}>Scope and purpose of use of collected information</h2>
      <p className="pb-1">NEDO automatically collects internet domain names, IP addresses, site search query information, and other information related to website visits (access logs). Such information is used for statistical analyses of website access trends and other purposes, and these results are used as a reference for future website management.</p>
      <p className="pb-2">NEDO’s website utilizes Google Analytics to analyze website access and Google Analytics utilizes cookies to collect access logs. Access logs are managed in accordance with Google's privacy policy. For more information, please visit Google's website.</p>
      <div className={styles.relatedLink}>
        <ul>
          <li className={styles.relatedLinkInnerList}><a className={`${styles.linkText} ${styles.outbound}`} href="https://policies.google.com/privacy?hl=en-US" target="_blank" rel="noopener noreferrer">Google privacy policy</a></li>
          <li className={styles.relatedLinkInnerList}><a className={`${styles.linkText} ${styles.outbound}`} href="https://marketingplatform.google.com/about/analytics/terms/us/" target="_blank" rel="noopener noreferrer">Google Analytics terms of service</a></li>
          <li className={styles.relatedLinkInnerList}><a className={`${styles.linkText} ${styles.outbound}`} href="https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage?hl=en-US" target="_blank" rel="noopener noreferrer">Use of cookies on websites by Google Analytics</a></li>
        </ul>
      </div>

      <h2 className={styles.pageContentsHeading2}>Personal information management</h2>
      <p className="pb-4">NEDO will strictly manage the personal information obtained on the Website and take necessary measures to prevent risks such as loss, leakage, abuse, or falsification of or unauthorized access to the personal information.</p>

      <h2 className={styles.pageContentsHeading2}>Change of this privacy policy</h2>
      <p className="pb-4">This privacy policy is subject to change without prior notice. The revised privacy policy will be posted on the Website.</p>

      <h2 className={styles.pageContentsHeading2}>EU General Data Protection Regulation (GDPR)</h2>
      <p className="pb-2">The General Data Projection Regulation (GDPR) came into force on May 25, 2018. For residents in the European Economic Area (EEA), which includes all EU member states, Iceland, Liechtenstein, and Norway, please be advised as follows:</p>
      <ul className="pb-4">
        <li>Personal data obtained through this website will be used only for the purpose specified when it is collected.</li>
        <li>Collected user personal data will be stored in servers installed by NEDO in Japan. Although Japan has not been recognized by the European Commission as providing an adequate level of data protection, NEDO will manage user personal data appropriately.</li>
        <li>Users of this website who have provided personal data may request access to their personal data for the purpose of confirmation of the accuracy of such data and rectification of any inaccuracy or the purpose of restriction of processing of personal data in order to verify the accuracy of such data. Users have the right to lodge a complaint with a supervisory authority in the EEA if they consider that processing of personal data relating to them infringes GDPR.</li>
        <li>By providing personal data to NEDO, users expressly consent to use of the data in accordance with NEDO’s privacy policy as stated above. Users have the right to withdraw their consent at any time. The withdrawal of consent does not affect the lawfulness of data processing or any transfer that may have taken place before withdrawal.</li>
      </ul>

      <h2 className={styles.pageContentsHeading2}>Contact information</h2>
      <p className="pb-1">Public Relations Department, NEDO</p>
      <p className="text-right">Last Updated : October 17, 2023</p>
      </main>

    </Layout>
  )
}

export default IndexPage

export const query = graphql`
  query($slug: String!) {
    markdownRemark(fields: {slug: {eq: $slug}}) {
      html
      frontmatter {
        title
        description
        slug
      }
    }
  }
`